import { capturarErro } from '../../services/monitoramento.js'
import {
  DESTINOS_POR_MOTIVO,
  ErroConfiguracaoTourGuiado,
  EVENTO_POSTHOG_INTERRUPCAO,
  FLUXO_SENTRY_TOUR_GUIADO,
  PREFIXO_FINGERPRINT_TOUR_GUIADO
} from '../utils/motivos_de_interrupcao.js'

export function criarRegistroDeInterrupcoes({ capturar, identificacao } = {}) {
  const emitidos = new Set()

  function chaveDeDedupe(motivo, dados) {
    return `${motivo}|${dados?.tour_id}|${dados?.indice_passo}`
  }

  function montarPayload(motivo, dados) {
    return {
      ...dados,
      motivo,
      pessoa_id: identificacao?.pessoa_id ?? null,
      empresa_id: identificacao?.empresa_id ?? null
    }
  }

  function enviarAoSentry(motivo, nivel, payload, erroOriginal) {
    try {
      const erro = erroOriginal ?? new ErroConfiguracaoTourGuiado(motivo)
      const fingerprint = erroOriginal
        ? undefined
        : [PREFIXO_FINGERPRINT_TOUR_GUIADO, motivo, String(payload.tour_id), String(payload.indice_passo)]
      capturarErro(erro, { fluxo: FLUXO_SENTRY_TOUR_GUIADO, extra: payload, nivel, fingerprint })
    } catch (erroDeEnvio) {
      console.warn('Tour guiado: falha ao registrar interrupção no Sentry:', erroDeEnvio)
    }
  }

  function enviarAoPosthog(payload) {
    try {
      capturar?.(EVENTO_POSTHOG_INTERRUPCAO, payload)
    } catch (erroDeEnvio) {
      console.warn('Tour guiado: falha ao registrar interrupção no PostHog:', erroDeEnvio)
    }
  }

  function registrar(motivo, dados, erroOriginal) {
    const destino = DESTINOS_POR_MOTIVO[motivo]
    if (!destino) return

    const chave = chaveDeDedupe(motivo, dados)
    if (emitidos.has(chave)) return
    emitidos.add(chave)

    const payload = montarPayload(motivo, dados)
    if (destino.sentry) enviarAoSentry(motivo, destino.sentry, payload, erroOriginal)
    if (destino.posthog) enviarAoPosthog(payload)
  }

  return { registrar }
}
